import { Route, Routes } from 'react-router-dom'
import { AccessTokensAccessLayout } from 'pages/settings/pages/developer/pages/accessTokens/layout/AccessTokensAccessLayout'
import { AccessTokensPageLayout } from 'pages/settings/pages/developer/pages/accessTokens/layout/AccessTokensPageLayout'
import { AccessTokensPage } from 'pages/settings/pages/developer/pages/accessTokens/ui/accessTokensPage'

export const AccessTokensRouter = () => {
  return (
    <Routes>
      <Route element={<AccessTokensAccessLayout />}>
        <Route element={<AccessTokensPageLayout />}>
          <Route path={'/'} element={<AccessTokensPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
